import { memo } from "react";
import { number, string } from "prop-types";
import { TooltipIcon } from "@components";
import { Badge } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import { AccountTreeRounded } from "@material-ui/icons";
import classnames from "classnames";

export const TaskChildrenTooltip = memo(({
  childrenAmount,
  className,
}) => {
  const { t } = useTranslation();
  const classes = useStyle();
  
  return (
    <Badge
      color="primary"
      badgeContent={childrenAmount}
      overlap="circular"
      max={9}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      className="button-description-view noDrag preset-taskActionButton"
      classes={{
        badge: classes.badge
      }}
    >
      <TooltipIcon
        color="primary"
        className={classnames("expand", className)}
        icon={<AccountTreeRounded />}
      >
        { t(`views.editor.${childrenAmount === 1 ? "child" : "children"}_below`, { childrenAmount }) }
      </TooltipIcon>
    </Badge>
  );
});

TaskChildrenTooltip.propTypes = {
  childrenAmount: number,
  className: string,
};

const useStyle = makeStyles((theme) => ({
  badge: {
    backgroundColor: theme.palette.primary.main,
  }
}));